"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workstreamsPageRedirectBehavior = exports.maintenancePageRedirectBehavior = exports.groupsPageRedirectBehavior = exports.manageUsersPageRedirectBehaviour = exports.localizedCategoriesRedirectBehavior = exports.casePortalPageRedirectBehavior = exports.notificationsPageRedirectBehavior = exports.inboxPageRedirectBehavior = exports.manageMembersPageRedirectBehaviour = exports.postGroupHubRedirectBehavior = exports.editGroupHubRedirectBehavior = exports.createGroupHubRedirectBehavior = exports.editCWPageRedirectBehavior = exports.editPageRedirectBehavior = exports.postPageRedirectBehavior = exports.messageReplyPageRedirectBehavior = exports.messagePageRedirectBehavior = exports.boardPageRedirectBehavior = exports.nodePageRedirectBehavior = exports.userRequiredRedirectBehavior = exports.noRedirectBehavior = exports.PathParamValidationType = exports.AccessFunctionType = exports.PageAccessRequiredContextObject = exports.RestrictedPageBehavior = void 0;
/*
 * Specifies the redirect behavior when a user cannot view a restricted page
 */
var RestrictedPageBehavior;
(function (RestrictedPageBehavior) {
    RestrictedPageBehavior["COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE"] = "communityPageWithAlertOrLoginPage";
    RestrictedPageBehavior["COMMUNITY_PAGE_OR_LOGIN_PAGE"] = "communityPageOrLoginPage";
    RestrictedPageBehavior["LOCALIZED_CATEGORIES_PAGE"] = "localizedCategoriesPage";
    RestrictedPageBehavior["NONE"] = "none";
})(RestrictedPageBehavior || (exports.RestrictedPageBehavior = RestrictedPageBehavior = {}));
/**
 * The required context object for a page. Some users receive a null response due to restrictions, so a requirement may be placed
 */
var PageAccessRequiredContextObject;
(function (PageAccessRequiredContextObject) {
    PageAccessRequiredContextObject["NODE"] = "node";
    PageAccessRequiredContextObject["MESSAGE"] = "message";
    PageAccessRequiredContextObject["USER"] = "user";
    PageAccessRequiredContextObject["NONE"] = "none";
})(PageAccessRequiredContextObject || (exports.PageAccessRequiredContextObject = PageAccessRequiredContextObject = {}));
/**
 * Which page access function to use for the page
 */
var AccessFunctionType;
(function (AccessFunctionType) {
    AccessFunctionType["POST_PAGE"] = "postPage";
    AccessFunctionType["EDIT_PAGE"] = "editPage";
    AccessFunctionType["CONTENT_WORKFLOW_EDIT_PAGE"] = "contentWorkflowEditPage";
    AccessFunctionType["CREATE_GROUP_HUB_PAGE"] = "createGroupHubPage";
    AccessFunctionType["EDIT_GROUP_HUB_PAGE"] = "editGroupHubPage";
    AccessFunctionType["POST_GROUP_HUB_PAGE"] = "postGroupHubPage";
    AccessFunctionType["LOCALIZED_CATEGORIES_PAGE"] = "localizedCategoriesPage";
    AccessFunctionType["MANAGE_MEMBERS_PAGE"] = "manageMembersPage";
    AccessFunctionType["MANAGE_USERS_PAGE"] = "manageUsersPage";
    AccessFunctionType["INBOX_PAGE"] = "inboxPage";
    AccessFunctionType["NOTIFICATIONS_PAGE"] = "notificationsPage";
    AccessFunctionType["CASE_PORTAL"] = "casePortal";
    AccessFunctionType["GROUPS_PAGE"] = "groupsPage";
    AccessFunctionType["MAINTENANCE_PAGE"] = "maintenancePage";
    AccessFunctionType["PII_FIELDS"] = "piiFields";
    AccessFunctionType["NONE"] = "none";
    AccessFunctionType["WORKSTREAMS_PAGE"] = "workstreamsPage";
})(AccessFunctionType || (exports.AccessFunctionType = AccessFunctionType = {}));
/**
 * Which path param validation to use for the page
 */
var PathParamValidationType;
(function (PathParamValidationType) {
    PathParamValidationType["BOARD"] = "board";
    PathParamValidationType["POST"] = "post";
    PathParamValidationType["EDIT"] = "edit";
    PathParamValidationType["MESSAGE"] = "message";
    PathParamValidationType["REPLY"] = "reply";
    PathParamValidationType["NONE"] = "none";
})(PathParamValidationType || (exports.PathParamValidationType = PathParamValidationType = {}));
// common redirect behaviors for pages are saved as const here for use within feature files //
exports.noRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.NONE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NONE,
        resolverFunctionType: AccessFunctionType.NONE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.userRequiredRedirectBehavior = Object.assign(Object.assign({}, exports.noRedirectBehavior), { pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.USER,
        resolverFunctionType: AccessFunctionType.NONE
    } });
exports.nodePageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NODE,
        resolverFunctionType: AccessFunctionType.NONE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.boardPageRedirectBehavior = Object.assign(Object.assign({}, exports.nodePageRedirectBehavior), { pathParamValidationType: PathParamValidationType.BOARD });
exports.messagePageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.MESSAGE,
        resolverFunctionType: AccessFunctionType.NONE
    },
    pathParamValidationType: PathParamValidationType.MESSAGE
};
exports.messageReplyPageRedirectBehavior = Object.assign(Object.assign({}, exports.messagePageRedirectBehavior), { pathParamValidationType: PathParamValidationType.REPLY });
exports.postPageRedirectBehavior = Object.assign(Object.assign({}, exports.nodePageRedirectBehavior), { pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NODE,
        resolverFunctionType: AccessFunctionType.POST_PAGE
    }, pathParamValidationType: PathParamValidationType.POST });
exports.editPageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.MESSAGE,
        resolverFunctionType: AccessFunctionType.EDIT_PAGE
    },
    pathParamValidationType: PathParamValidationType.EDIT
};
exports.editCWPageRedirectBehavior = Object.assign(Object.assign({}, exports.editPageRedirectBehavior), { pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.MESSAGE,
        resolverFunctionType: AccessFunctionType.CONTENT_WORKFLOW_EDIT_PAGE
    } });
exports.createGroupHubRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NONE,
        resolverFunctionType: AccessFunctionType.CREATE_GROUP_HUB_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.editGroupHubRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NODE,
        resolverFunctionType: AccessFunctionType.EDIT_GROUP_HUB_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.postGroupHubRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NODE,
        resolverFunctionType: AccessFunctionType.POST_GROUP_HUB_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.manageMembersPageRedirectBehaviour = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NODE,
        resolverFunctionType: AccessFunctionType.MANAGE_MEMBERS_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.inboxPageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.USER,
        resolverFunctionType: AccessFunctionType.INBOX_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.notificationsPageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.USER,
        resolverFunctionType: AccessFunctionType.NOTIFICATIONS_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.casePortalPageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NONE,
        resolverFunctionType: AccessFunctionType.CASE_PORTAL
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.localizedCategoriesRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.LOCALIZED_CATEGORIES_PAGE,
    pageAccessResolver: {
        resolverFunctionType: AccessFunctionType.LOCALIZED_CATEGORIES_PAGE,
        requiredContextObject: PageAccessRequiredContextObject.NONE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.manageUsersPageRedirectBehaviour = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.USER,
        resolverFunctionType: AccessFunctionType.MANAGE_USERS_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.groupsPageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.LOCALIZED_CATEGORIES_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NONE,
        resolverFunctionType: AccessFunctionType.GROUPS_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.maintenancePageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.NONE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NONE,
        resolverFunctionType: AccessFunctionType.MAINTENANCE_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
exports.workstreamsPageRedirectBehavior = {
    restrictedPageBehavior: RestrictedPageBehavior.COMMUNITY_PAGE_WITH_ALERT_OR_LOGIN_PAGE,
    pageAccessResolver: {
        requiredContextObject: PageAccessRequiredContextObject.NONE,
        resolverFunctionType: AccessFunctionType.WORKSTREAMS_PAGE
    },
    pathParamValidationType: PathParamValidationType.NONE
};
//# sourceMappingURL=index.js.map